module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/account-closure-grid/account-closure-grid.component.css
// module id = ./src/app/accountmaster/account-closure-grid/account-closure-grid.component.css
// module chunks = main